import { AdminSearch } from '@platform/client';
import { useState } from 'react';
import { AdminListPageWrapper } from '../../AdminListPage';
import { DownloadResultsModal } from './DownloadResultsModal';
import { ProUserSearchForm, ProUserFilters } from './ProUserSearchForm';
import { ProUserResultsTable } from './ProUserResultsTable';

export const ProUserSearchPage = () => {
  const [filters, setFilters] = useState<ProUserFilters>();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);

  return (
    <>
      {!filters && <ProUserSearchForm setFilters={setFilters} />}
      {filters && (
        <AdminListPageWrapper title='Results preview'>
          <ProUserResultsTable
            filters={filters}
            setFilters={setFilters}
            setDownloadModalOpen={setDownloadModalOpen}
          />
        </AdminListPageWrapper>
      )}
      {downloadModalOpen && filters && (
        <DownloadResultsModal
          onClose={() => setDownloadModalOpen(false)}
          filters={filters}
          userType='pro'
          fetchFn={AdminSearch.useGetProResultExportData}
        />
      )}
    </>
  );
};
